import type { MappingLocationsResponse } from '@/entities/dashboard/mapping';

import type { ClusterNameResolver, MapGroupBy } from '../model/types';

const NAME_SOURCES = {
  country: 'countries',
  region: 'regions',
  subregion: 'subregions',
  locationGroup: 'sites'
} as const satisfies Record<Exclude<MapGroupBy, 'location'>, keyof MappingLocationsResponse>;

/**
 * Cluster names come from the same `/locations` payload that carries the geography,
 * so grouping needs no extra request. Ids arrive as numbers, hence the `String`.
 */
export function createClusterNameResolver(
  data: MappingLocationsResponse | undefined,
  groupBy: MapGroupBy
): ClusterNameResolver {
  const entries = data && groupBy !== 'location' ? data[NAME_SOURCES[groupBy]] : [];
  const names = new Map(entries.map((entry) => [String(entry.id), entry.name]));

  return (id) => names.get(id) ?? id;
}
